import store from '../store/index.js';
import util from '../utils/index.js';

function myWs() {
  let isHttps = 'https:' == document.location.protocol ? true : false
  let col = isHttps ? "wss://" : "ws://"
  var _this = this;
  this.status = 0; //0，closed，1，open 36.152.34.21 oa.nlxdt.com  oa.newlixon.com
  this.unSendMsgs = [];
  this.open = function (userToken) {
    let ts = '36.152.34.21:5001'
    // let ts = '192.168.10.132:5002'
    if (location.href.indexOf("oa.newlixon.com") > -1) {
      ts = isHttps ? 'oa.newlixon.com' : 'oa.newlixon.com:5001'
    }
    _this._ws = new WebSocket(col + ts + "/ims?token=" + userToken + "&platform=WEB");
    // _this._ws = new WebSocket(col + ts + "/ims?token=" + userToken + "&platform=WEB");
    _this._ws.onopen = function () {
      console.log("socket已连接。。。");
      _this.status = 1;
      _this.unSendMsgs.forEach((evt) => {
        if (typeof evt == 'function') {
          evt();
        } else {
          _this._ws.send(evt);
        }
      })
    }
    _this._ws.onclose = function () {
      _this.status = 0;
      console.log("socket已断开。。。");
      store.commit('CHANGE_SOCKET', null);
    }
    _this._ws.onmessage = function (evt) {
      console.log(evt.data);
      const data = JSON.parse(evt.data);
      // 账号在其他入口登录
      if (data && data.code == '5102') {
        // _this.otherLogout('你的账号已在另一台设备上登录，请重新登录');
      } else if (data && data.code == '5103') {
        // let title = data.bean && data.bean.messageContent || 0;
        let title = Math.ceil(Math.random() * 10000);
        store.commit('CHANGE_NUM', title);
      } else {
        // app端退出时
        if (data.bean && data.bean.messageContent && data.bean.messageContent.type == '0') {
          _this.logout(data);
        }
      }
    }
  }
  this.send = function (data) {
    if (_this.status == 1) {
      console.log(data)
      _this._ws.send(data);
    } else {
      _this.unSendMsgs.push(data);
    }
  }
  this.close = function () {
    _this.unSendMsgs = [];
    if (_this._ws) {
      _this._ws.close();
    }
    _this._ws = null;
  }
  this.logout = function () {}
  this.otherLogout = function () {}
}

var initSocket = function (userToken) {
  const _ws = new myWs();
  _ws.open(userToken);
  _ws.logout = function (data) {
    console.log("App端退出登录了");
    store.commit('CHANGE_LOGOUT', true);
    _ws.otherLogout('App端退出登录');
  }
  _ws.otherLogout = function (msg) {
    console.log("账号在其他入口登录");
    util.toast(msg, 2000);
    store.commit('CHANGE_OTHERLOGOUT', true);
    util.setCookie("loginCheck", "");
    util.clearCookie('userToken');
    _ws.close();
    window.location.href = '/login'
    store.commit('CHANGE_IsShow', false);
    store.commit('CHANGE_USERINFO', null);
  }
  store.commit('CHANGE_SOCKET', _ws);
}

var socket = {
  initSocket: initSocket
}

export default socket;



// WEBPACK FOOTER //
// ./src/api/socket.js